import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import Amount from 'design-system/Amount';
import IconEmmaWallet from 'design-system/icons/IconEmmaWallet';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { InternalTransfer } from 'features/transfers/types';
import { useConnectedAccount } from '../hooks/selectors';
import { selectTradingAccount } from '../reducers/selectors';
import { blockInvestActionOnWeb } from '../webGate';
import { isWeb } from '../../../constants';
const TradingAccountCashRow = () => {
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const connectedAccount = useConnectedAccount();
    const tradingAccount = useAppSelector(selectTradingAccount);
    const handleWithdraw = React.useCallback(() => {
        if (blockInvestActionOnWeb('Withdraw'))
            return;
        if (tradingAccount?.account.id && connectedAccount) {
            navigation.navigate('Transfer', {
                to: { ...connectedAccount, itemType: 'investConnectedAccount' },
                from: {
                    id: tradingAccount.account.id,
                    itemType: 'SecclAccountItem',
                },
                type: InternalTransfer.withdraw,
            });
        }
    }, [connectedAccount, tradingAccount?.account.id]);
    if (tradingAccount && !!tradingAccount.account.cashTotal) {
        const { aer, cashTotal, availableToInvest } = tradingAccount.account;
        const renderAvailable = availableToInvest?.value !== cashTotal?.value;
        return (<TouchableHighlight hoverOnLight onCard={isWeb} activeOpacity={1} onPress={handleWithdraw} underlayColor={colors.background.underlay} disabled={!availableToInvest?.value || tradingAccount?.account.accountType === 'JISA'}>
        <View style={styles.container}>
          <IconEmmaWallet />
          <View style={styles.flex}>
            <Text Text-16>Cash</Text>
            {!!aer && (<Text TextThin-14 Secondary>
                <Text NumbersThin-14 Secondary>
                  {aer.toFixed(2)}%
                </Text>{' '}
                AER
              </Text>)}
          </View>
          <View style={styles.rightContainer}>
            <Amount Numbers-16 value={cashTotal}/>
            {!!renderAvailable && !!availableToInvest && (<View style={styles.row}>
                <Amount NumbersThin-14 Secondary value={availableToInvest}/>
                <Text TextThin-14 Secondary>
                  {' available'}
                </Text>
              </View>)}
          </View>
        </View>
      </TouchableHighlight>);
    }
    return null;
};
export default React.memo(TradingAccountCashRow);
const styles = StyleSheet.create({
    container: {
        gap: rem(16),
        padding: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
        // On web the card is padded by 8 and each row by 8, so the hover highlight sits inside the card
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
    flex: {
        flex: 1,
    },
    rightContainer: {
        alignItems: 'flex-end',
    },
    row: {
        flexDirection: 'row',
    },
});
